import './cartStyles.scss'
import { PrescriptionIcon, TruckFastIcon } from '@quickmd-llc/design-system'
import { Step, useProductOrderContext } from 'components/product-order-popup/context'
import { useCallback } from 'react'

export const Cart = () => {
  const { cartItems, isMHTHomeDelivery, goToStep, currentStepId, previousCartStep } = useProductOrderContext()

  const onClick = useCallback(() => {
    previousCartStep.current = currentStepId
    goToStep(Step.VIEW_CART)
  }, [currentStepId, goToStep, previousCartStep])

  return (
    <div role='presentation' className='cart-container' onClick={onClick}>
      {isMHTHomeDelivery ?
        <TruckFastIcon style={{ color: '#178199' }} />
      : <PrescriptionIcon style={{ color: '#178199' }} />}
      <div className='cart-total-text'>{cartItems.length}</div>
    </div>
  )
}
